module.exports = __webpack_public_path__ + "img/jeton.b21be3bc.svg";